// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:base-models --tenant projectReplica` to regenerate.
import DatabaseRecord from "velocious/build/src/database/record/index.js"

/**
 * Attributes accepted when creating or updating Timelog records.
 * @typedef {object} TimelogWriteAttributes
 * @property {string} [id] - Value for the id attribute.
 * @property {string | null} [taskId] - Value for the taskId attribute.
 * @property {string | null} [userId] - Value for the userId attribute.
 * @property {Date | string | null} [date] - Value for the date attribute.
 * @property {number | null} [timeSeconds] - Value for the timeSeconds attribute.
 * @property {number | null} [timeTransportSeconds] - Value for the timeTransportSeconds attribute.
 * @property {number | null} [transportLength] - Value for the transportLength attribute.
 * @property {string | null} [comment] - Value for the comment attribute.
 * @property {boolean} [invoiced] - Value for the invoiced attribute.
 * @property {Date | string} [createdAt] - Value for the createdAt attribute.
 * @property {Date | string} [updatedAt] - Value for the updatedAt attribute.
 * @property {Date | string | null} [lastSyncChangeAt] - Value for the lastSyncChangeAt attribute.
 * @property {import("../models/task.js").default} [task] - Related task record.
 */

/** @augments {DatabaseRecord<TimelogWriteAttributes>} */
export default class TimelogBase extends DatabaseRecord {
  /** @returns {typeof import("../models/timelog.js").default} */
  // @ts-ignore - override narrows return type for better IntelliSense in generated model bases
  getModelClass() { return /** @type {typeof import("../models/timelog.js").default} */ (this.constructor) }

  /** @returns {string} */
  id() { return this.readAttribute("id") }

  /**
   * @param {string} newValue
   * @returns {void}
   */
  setId(newValue) { return this._setColumnAttribute("id", newValue) }

  /** @returns {boolean} */
  hasId() { return this._hasAttribute(this.id()) }

  /** @returns {string | null} */
  taskId() { return this.readAttribute("taskId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setTaskId(newValue) { return this._setColumnAttribute("taskId", newValue) }

  /** @returns {boolean} */
  hasTaskId() { return this._hasAttribute(this.taskId()) }

  /** @returns {string | null} */
  userId() { return this.readAttribute("userId") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setUserId(newValue) { return this._setColumnAttribute("userId", newValue) }

  /** @returns {boolean} */
  hasUserId() { return this._hasAttribute(this.userId()) }

  /** @returns {Date | null} */
  date() { return this.readAttribute("date") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setDate(newValue) { return this._setColumnAttribute("date", newValue) }

  /** @returns {boolean} */
  hasDate() { return this._hasAttribute(this.date()) }

  /** @returns {number | null} */
  timeSeconds() { return this.readAttribute("timeSeconds") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setTimeSeconds(newValue) { return this._setColumnAttribute("timeSeconds", newValue) }

  /** @returns {boolean} */
  hasTimeSeconds() { return this._hasAttribute(this.timeSeconds()) }

  /** @returns {number | null} */
  timeTransportSeconds() { return this.readAttribute("timeTransportSeconds") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setTimeTransportSeconds(newValue) { return this._setColumnAttribute("timeTransportSeconds", newValue) }

  /** @returns {boolean} */
  hasTimeTransportSeconds() { return this._hasAttribute(this.timeTransportSeconds()) }

  /** @returns {number | null} */
  transportLength() { return this.readAttribute("transportLength") }

  /**
   * @param {number | null} newValue
   * @returns {void}
   */
  setTransportLength(newValue) { return this._setColumnAttribute("transportLength", newValue) }

  /** @returns {boolean} */
  hasTransportLength() { return this._hasAttribute(this.transportLength()) }

  /** @returns {string | null} */
  comment() { return this.readAttribute("comment") }

  /**
   * @param {string | null} newValue
   * @returns {void}
   */
  setComment(newValue) { return this._setColumnAttribute("comment", newValue) }

  /** @returns {boolean} */
  hasComment() { return this._hasAttribute(this.comment()) }

  /** @returns {boolean} */
  invoiced() { return this.readAttribute("invoiced") }

  /**
   * @param {boolean} newValue
   * @returns {void}
   */
  setInvoiced(newValue) { return this._setColumnAttribute("invoiced", newValue) }

  /** @returns {boolean} */
  hasInvoiced() { return this._hasAttribute(this.invoiced()) }

  /** @returns {Date} */
  createdAt() { return this.readAttribute("createdAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setCreatedAt(newValue) { return this._setColumnAttribute("createdAt", newValue) }

  /** @returns {boolean} */
  hasCreatedAt() { return this._hasAttribute(this.createdAt()) }

  /** @returns {Date} */
  updatedAt() { return this.readAttribute("updatedAt") }

  /**
   * @param {Date | string} newValue
   * @returns {void}
   */
  setUpdatedAt(newValue) { return this._setColumnAttribute("updatedAt", newValue) }

  /** @returns {boolean} */
  hasUpdatedAt() { return this._hasAttribute(this.updatedAt()) }

  /** @returns {Date | null} */
  lastSyncChangeAt() { return this.readAttribute("lastSyncChangeAt") }

  /**
   * @param {Date | string | null} newValue
   * @returns {void}
   */
  setLastSyncChangeAt(newValue) { return this._setColumnAttribute("lastSyncChangeAt", newValue) }

  /** @returns {boolean} */
  hasLastSyncChangeAt() { return this._hasAttribute(this.lastSyncChangeAt()) }

  /**
   * @returns {import("../models/task.js").default}
   */
  task() { return /** @type {import("../models/task.js").default} */ (this.getRelationshipByName("task").loaded()) }

  /**
   * @abstract
   * @param {ConstructorParameters<typeof import("../models/task.js").default>[0]} [attributes]
   * @returns {import("../models/task.js").default}
   */
  buildTask(attributes) { void attributes; throw new Error("Not implemented") }

  /**
   * @abstract
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  loadTask() { throw new Error("Not implemented") }

  /**
   * @returns {Promise<import("../models/task.js").default | undefined>}
   */
  taskOrLoad() { return /** @type {Promise<import("../models/task.js").default | undefined>} */ (this.relationshipOrLoad("task")) }

  /**
   * @abstract
   * @param {import("../models/task.js").default} newModel
   * @returns {void}
   */
  setTask(newModel) { void newModel; throw new Error("Not implemented") }
}
